import { render, staticRenderFns } from "./RightPanel2.vue?vue&type=template&id=2a12484d&scoped=true"
import script from "./RightPanel2.vue?vue&type=script&lang=js"
export * from "./RightPanel2.vue?vue&type=script&lang=js"
import style0 from "./RightPanel2.vue?vue&type=style&index=0&id=2a12484d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a12484d",
  null
  
)

export default component.exports